<div class="card-body">
    <canvas #chartCanvas id="{{chartId}}"></canvas>
</div>
